import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

interface HomeSectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  action?: React.ReactNode;
}

const HomeSectionHeader: React.FC<HomeSectionHeaderProps> = ({
  icon,
  title,
  subtitle,
  action,
}) => (
  <Paper
    variant="outlined"
    sx={{ borderRadius: 2, overflow: "hidden", mb: 2 }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        px: 2.5,
        py: 2,
        bgcolor: "grey.50",
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center">
        {icon}
        <Box>
          <Typography
            variant="subtitle1"
            component="h2"
            sx={{ fontWeight: 700, lineHeight: 1.3 }}
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
      </Stack>
      {action}
    </Box>
  </Paper>
);

export default HomeSectionHeader;
